"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import Vue from "vue";
import i18n from "@/lang";
import VueRouter from "vue-router";
import API from "@ym-framework/api-utils";
import AppMy from "@/views/application/AppMy.vue";
import AppMain from "@/views/application/AppMain.vue";
import AppDetail from "@/views/application/AppDetail.vue";
import { AuthAccess, GuestAccess, AccountAccess, MainPageAccess, LogoutAccess, UserAccess, MessageAccess, ToManagerAccess, VeiwOptions, AppAccess, LogAccess } from "@/access-rules";
import PaymentMain from "@/views/payItems/PaymentMain.vue";
import PaymentConfirmation from "@/views/payItems/PaymentConfirmation.vue";
import CouponItem from "@/views/costItems/components/CouponItem.vue";
import VDCardItem from "@/views/costItems/components/VDCardItem.vue";
import Welcome from "@/views/Welcome.vue";
import VdSettingView from "@/views/VdSettingView.vue";
import VirtualDesktopHome from "@/views/VirtualDesktopHome.vue";
import VirtualShopHome from "@/views/VirtualShopHome.vue";
import TeamManager from "@/views/managements/teammanager/TeamManager.vue";
import LogsManager from "@/views/managements/logsmanager/LogsManager.vue";
import AccountManagement from "@/views/managements/accountmanager/AccountManager.vue";
import CostManager from "@/views/managements/paymentmanager/CostManager.vue";
import ShopDetail from "@/views/virtual-shop/ShopDetail.vue";
import UserManager from "@/views/managements/usermanager/UserManager.vue";
import OpenApiManager from "@/views/managements/openapimanager/OpenApiManager.vue";
import EmptyElement from "@/components/none-page/EmptyElement.vue";
import MessageView from "@/views/messageItems/MessageView.vue";
import Register from "@/app_views/register/Register.vue";
import RegisterDiscard from "@/app_views/register/RegisterDiscard.vue";
import ForgetPassword from "@/app_views/register/ForgetPassword.vue";
import Register3 from "@/app_views/register/Register3.vue";
import RegisterSuccess from "@/app_views/register/RegisterSuccess.vue";
import BindWeiXin3 from "@/app_views/register/BindWeixin3.vue";
import BindWeixinSuccess from "@/app_views/register/BindWeixinSuccess.vue";
import BindWeixinFail from "@/app_views/register/BindWeixinFail.vue";
import TeamInviteRegister from "@/app_views/inviteTeam/TeamInviteRegister.vue";
import TeamInviteLogin from "@/app_views/inviteTeam/TeamInviteLogin.vue";
import InviteFailed from "@/app_views/inviteTeam/InviteFailed.vue";
import InviteSuccess from "@/app_views/inviteTeam/InviteSuccess.vue";
import InviteRegisterSuccess from "@/app_views/inviteTeam/RegisterSuccess.vue";
import AuthBubble from "@/app_views/login/AuthBubble.vue";
import Setting from "@/app_views/settings/Setting.vue";
import FeedBackMain from "@/views/FeedbackItems/FeedBackMain.vue";
import HomePage from "@/app_views/homePage/HomePage.vue";
import MessageMain from "@/views/messageItems/MessageMain.vue";
import MessageDetail from "@/views/messageItems/MessageItem.vue";
import AddRules from "@/views/managements/safemanager/AddRulesPage.vue";
import AddWebPageByHand from "@/views/managements/safemanager/addWebPages/AddWebPagesByHand.vue";
import AI from "@/views/managements/aimanager/AI.vue";
import PaymentNewTraffic from "@/views/payItems/components/PaymentNewTraffic.vue";
import VirtualDesktopTrafficDetail from "@/views/virtual-desktop/VirtualDesktopTrafficDetail.vue";
import AccessManager from "@/views/safemanagements/AccessManager/AccessManager.vue";
import InprogressManager from "@/views/safemanagements/InprogressManager/InprogressManager.vue";
import WebResourceManager from "@/views/safemanagements/WebResourceManager/WebResourcesController.vue";
import MoreSafeManager from "@/views/safemanagements/MoreSafeManager/MoreSafeManager.vue";
import ConfigEarlyWarning from "@/views/safemanagements/InprogressManager/components/ConfigEarlyWarning.vue";
import MonitorLogDetail from "@/views/safemanagements/InprogressManager/components/MonitorLogDetail.vue";
import PurchaseService from "@/views/payItems/PayPurchaseService.vue";
import PayAdditionalPurchase from "@/views/payItems/PayAdditionalPurchase.vue";
import PaymentPurchaseConfirmation from "@/views/payItems/PaymentPurchaseConfirmation.vue";
import AddRoles from "@/views/managements/teammanager/components/AddRoles.vue";
Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    name: "virtual-desktop",
    meta: {
      mode: "virtual-desktop",
      access: new MainPageAccess(),
      title: i18n.t("appdetail.home_page")
    },
    component: VirtualDesktopHome
  },
  {
    path: "/virtual-shop",
    name: "virtual-shop",
    meta: {
      mode: "virtual-shop",
      access: new AccountAccess(),
      title: i18n.t("appdetail.home_page")
    },
    component: VirtualShopHome
  },
  {
    path: "/main",
    name: "Main",
    meta: {
      mode: "virtual-desktop",
      access: new MainPageAccess(),
      title: i18n.t("appdetail.home_page"),
      menuactive: 2
    },
    component: VirtualDesktopHome
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    meta: {
      mode: "virtual-desktop",
      access: new MainPageAccess(),
      title: i18n.t("appdetail.home_page")
    },
    component: VirtualDesktopHome
  },
  {
    path: "/team",
    name: "Team",
    meta: {
      access: new AuthAccess(),
      // access:new AccountAccess(),
      title: i18n.t("layout.team_management"),
      menuactive: 3
    },
    component: TeamManager
  },
  {
    path: "/account_management",
    name: "AccountManagement",
    meta: {
      access: new AuthAccess(),
      title: i18n.t("layout.account_management"),
      menuactive: 6
    },
    component: AccountManagement
  },
  {
    path: "/cost_management",
    name: "CostManagement",
    meta: {
      access: new AccountAccess(),
      title: i18n.t("layout.expense_management"),
      menuactive: 7
    },
    component: CostManager
  },
  // {
  //   path: '/security',
  //   name: 'Security',
  //   meta: {
  //     access: new AuthAccess(),
  //     title: i18n.t('layout.safety_management') as string,
  //     menuactive: 4,
  //   },
  //   component: SafeManager
  // },
  {
    path: "/security",
    name: "Security",
    meta: {
      access: new AuthAccess(),
      title: i18n.t("layout.safety_management"),
      menuactive: 1
    },
    component: AccessManager
  },
  {
    path: "/midsafety",
    name: "MidSafety",
    meta: {
      access: new AuthAccess(),
      title: i18n.t("layout.mid_safety_management"),
      menuactive: 2
    },
    component: InprogressManager
  },
  {
    path: "/web_resource",
    name: "WebResourceManager",
    meta: {
      access: new AuthAccess(),
      title: i18n.t("layout.web_page_resource"),
      menuactive: 3
    },
    component: WebResourceManager
  },
  {
    path: "/more_safe_manager",
    name: "MoreSafeManager",
    meta: {
      access: new AuthAccess(),
      title: i18n.t("layout.more_safety"),
      menuactive: 4
    },
    component: MoreSafeManager
  },
  {
    path: "/openapi",
    name: "OpenApi",
    meta: {
      access: new AccountAccess(),
      title: i18n.t("layout.openapi_management"),
      menuactive: 8
    },
    component: OpenApiManager
  },
  {
    path: "/options",
    name: "Options",
    meta: {
      access: new LogAccess(),
      title: i18n.t("layout.operation_log"),
      menuactive: 5
    },
    component: LogsManager
  },
  {
    path: "/account",
    name: "AccountManagement",
    meta: {
      access: new AuthAccess(),
      title: i18n.t("layout.account_management"),
      menuactive: 6
    },
    component: AccountManagement
  },
  {
    path: "/account_child",
    name: "AccountChild",
    meta: {
      access: new UserAccess(),
      title: i18n.t("layout.account_management"),
      menuactive: 6
    },
    component: UserManager
  },
  {
    path: "/cost",
    name: "CostManagement",
    meta: {
      access: new AccountAccess(),
      title: i18n.t("layout.expense_management"),
      menuactive: 7
    },
    component: CostManager
  },
  {
    path: "/coupon_item",
    name: "couponItem",
    meta: {
      access: new AccountAccess(),
      title: i18n.t("couponitem.coupon"),
      menuactive: 9
    },
    component: CouponItem
  },
  {
    path: "/vdcard_item",
    name: "vdcardItem",
    meta: {
      access: new AuthAccess(),
      title: i18n.t("recharge.card"),
      menuactive: 10
    },
    component: VDCardItem
  },
  {
    path: "/app",
    name: "app",
    meta: {
      access: new AccountAccess(),
      menuactive: 11,
      title: i18n.t("appdetail.application_center")
    },
    component: AppMain
  },
  {
    path: "/appdetail",
    name: "appdetail",
    meta: {
      access: new AccountAccess(),
      title: i18n.t("appdetail.application_detail"),
      menuactive: 12
    },
    component: AppDetail
  },
  {
    path: "/myapp",
    name: "myapp",
    meta: {
      access: new AccountAccess(),
      title: i18n.t("apphead.my_application"),
      menuactive: 13
    },
    component: AppMy
  },
  {
    path: "/payment",
    name: "payment",
    meta: {
      access: new AccountAccess(),
      title: i18n.t("paymentmain.payment_center"),
      menuactive: 14
    },
    component: PaymentMain
  },
  {
    path: "/payment_confirmation",
    name: "PaymentConfirmation",
    meta: {
      access: new AccountAccess(),
      title: i18n.t("paymentconfirmation.order_reconciliation_and_payment"),
      menuactive: 15,
      options: new VeiwOptions((to, from, next) => __async(void 0, null, function* () {
        return API.get(`api://base.auth/api/v7/orders/${to.query.id}`);
      }))
    },
    component: PaymentConfirmation
  },
  {
    path: "/welcome",
    name: "Welcome",
    meta: {
      access: new AccountAccess(),
      title: i18n.t("welcome.title"),
      menuactive: 17
    },
    component: Welcome
  },
  {
    path: "/feedback",
    name: "Feedback",
    meta: {
      access: new AccountAccess(),
      title: i18n.t("layout.user_feedback")
    },
    component: FeedBackMain
  },
  {
    path: "/home",
    name: "Home",
    meta: {
      access: new AppAccess(),
      title: i18n.t("layout.homepage_title")
    },
    component: HomePage
  },
  {
    path: "/message_view",
    name: "MessageView",
    meta: {
      access: new MessageAccess(),
      title: i18n.t("layout.mee")
    },
    component: MessageView
  },
  {
    path: "/message_main",
    name: "MessageMain",
    meta: {
      access: new AccountAccess(),
      title: i18n.t("layout.mee_main")
    },
    component: MessageMain
  },
  {
    path: "/message_detail",
    name: "MessageDetail",
    meta: {
      access: new AccountAccess(),
      title: i18n.t("layout.mee_detail")
    },
    component: MessageDetail
  },
  {
    path: "/vdsetting",
    name: "VdSettingView",
    meta: {
      access: new AccountAccess(),
      title: i18n.t("appdetail.vd_setting_view")
    },
    component: VdSettingView
  },
  {
    path: "/logout",
    name: "Logout",
    meta: {
      access: new LogoutAccess(),
      title: "\u9000\u51FA\u767B\u5F55"
    }
  },
  {
    path: "/to_manager",
    name: "ToManager",
    meta: {
      access: new ToManagerAccess()
    }
  },
  {
    path: "/teamManager",
    name: "TeamManager",
    meta: {
      access: new GuestAccess(),
      title: i18n.t("router.loading.title")
    },
    component: TeamManager
  },
  {
    path: "/shopDetail",
    name: "ShopDetail",
    meta: {
      access: new AccountAccess(),
      title: i18n.t("router.shop_detail.title")
    },
    component: ShopDetail
  },
  {
    path: "/404",
    name: "404",
    meta: {
      access: new GuestAccess(),
      title: i18n.t("router.loading.title")
    },
    component: EmptyElement
  },
  {
    path: "/register",
    name: "Register",
    meta: {
      access: new AppAccess(),
      title: i18n.t("phonelogin.account_register")
    },
    component: Register
  },
  {
    path: "/register3",
    name: "Register",
    meta: {
      access: new AppAccess(),
      title: i18n.t("phonelogin.account_register")
    },
    component: Register3
  },
  {
    path: "/register_success",
    name: "RegisterSuccess",
    meta: {
      access: new AppAccess(),
      title: i18n.t("phonelogin.account_register")
    },
    component: RegisterSuccess
  },
  {
    path: "/bindweixin3",
    name: "BindWeiXin",
    meta: {
      access: new AppAccess(),
      title: i18n.t("phonelogin.bind_weixin")
    },
    component: BindWeiXin3
  },
  {
    path: "/bindweixin_success",
    name: "BindWeiXinSuccess",
    meta: {
      access: new AppAccess(),
      title: i18n.t("phonelogin.bind_weixin")
    },
    component: BindWeixinSuccess
  },
  {
    path: "/bindweixin_fail",
    name: "BindWeiXinFail",
    meta: {
      access: new AppAccess(),
      title: i18n.t("phonelogin.bind_weixin")
    },
    component: BindWeixinFail
  },
  {
    path: "/register_discard",
    name: "RegisterSuccess",
    meta: {
      access: new AppAccess(),
      title: i18n.t("phonelogin.account_register")
    },
    component: RegisterDiscard
  },
  {
    path: "/forgetpassword",
    name: "ForgetPassword",
    meta: {
      access: new AppAccess(),
      title: i18n.t("phonelogin.forget_password")
    },
    component: ForgetPassword
  },
  {
    path: "/team_invite/register",
    name: "TeamInviteRegister",
    meta: {
      access: new AppAccess(),
      title: i18n.t("phonelogin.team_invite_register")
    },
    component: TeamInviteRegister
  },
  {
    path: "/team_invite/login",
    name: "TeamInviteLogin",
    meta: {
      access: new AppAccess(),
      title: i18n.t("phonelogin.team_invite_login")
    },
    component: TeamInviteLogin
  },
  {
    path: "/team_invite/failed",
    name: "TeamInviteFailed",
    meta: {
      access: new AppAccess(),
      title: i18n.t("phonelogin.team_invite_failed")
    },
    component: InviteFailed
  },
  {
    path: "/team_invite/success",
    name: "TeamInviteSuccess",
    meta: {
      access: new AppAccess(),
      title: i18n.t("phonelogin.team_invite_success")
    },
    component: InviteSuccess
  },
  {
    path: "/team_invite/register_success",
    name: "RegisterSuccess",
    meta: {
      access: new AppAccess(),
      title: i18n.t("phonelogin.team_invite_failed")
    },
    component: InviteRegisterSuccess
  },
  {
    path: "/auth_login",
    name: "Login",
    meta: {
      access: new GuestAccess(),
      title: i18n.t("phonelogin.login_title")
    },
    component: AuthBubble
  },
  {
    path: "/setting",
    name: "Setting",
    meta: {
      access: new GuestAccess(),
      title: i18n.t("phonelogin.setting_title")
    },
    component: Setting
  },
  {
    path: "/add_rules",
    name: "AddRules",
    meta: {
      access: new AccountAccess(),
      title: i18n.t("phonelogin.add_rules_title")
    },
    component: AddRules
  },
  {
    path: "/add_web_pages_handle",
    name: "AddWebPages",
    meta: {
      access: new AccountAccess(),
      title: i18n.t("phonelogin.add_web_pages_title")
    },
    component: AddWebPageByHand
  },
  {
    path: "/ai",
    name: "AI",
    meta: {
      access: new AccountAccess(),
      title: i18n.t("phonelogin.ai_title")
    },
    component: AI
  },
  {
    path: "/add_roles",
    name: "AddRoles",
    meta: {
      access: new AccountAccess(),
      title: i18n.t("add_roles.title")
    },
    component: AddRoles
  },
  {
    path: "/traffic",
    name: "PaymentNewTraffic",
    meta: {
      access: new AccountAccess(),
      title: i18n.t("paymentnewtraffic.title")
    },
    component: PaymentNewTraffic
  },
  {
    path: "/traffic_detail",
    name: "TrafficDetail",
    meta: {
      access: new AccountAccess(),
      title: i18n.t("traffic_detail.title")
    },
    component: VirtualDesktopTrafficDetail
  },
  {
    path: "/config_early_warning",
    name: "ConfigEarlyWarning",
    meta: {
      access: new AccountAccess(),
      title: i18n.t("config_early_warning.title")
    },
    component: ConfigEarlyWarning
  },
  {
    path: "/monitor_log_detail",
    name: "MonitorLogDetail",
    meta: {
      access: new AccountAccess(),
      title: i18n.t("monitor_log_detail.title")
    },
    component: MonitorLogDetail
  },
  {
    path: "/purchase_service",
    name: "PurchaseService",
    meta: {
      access: new AccountAccess(),
      title: i18n.t("purchase_service.title")
    },
    component: PurchaseService
  },
  {
    path: "/pay_additional_purchase",
    name: "PayAdditionalPurchase",
    meta: {
      access: new AccountAccess(),
      title: i18n.t("pay_additional_purchase.title")
    },
    component: PayAdditionalPurchase
  },
  {
    path: "/payment_purchase_confirmation",
    name: "PaymentPurchaseConfirmation",
    meta: {
      access: new AccountAccess(),
      title: i18n.t("paymentconfirmation.order_reconciliation_and_payment"),
      menuactive: 15
    },
    component: PaymentPurchaseConfirmation
  },
  {
    path: "*",
    name: "*",
    meta: {
      title: i18n.t("router.loading.title")
    },
    //@ts-ignore
    redirect: (to) => {
      return { path: "/", query: null };
    }
  }
];
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});
router.beforeEach((to, from, next) => __async(void 0, null, function* () {
  var _a, _b, _c, _d;
  if (to.hash.indexOf("#/auth") !== -1 && to.hash.indexOf("refer") !== -1) {
    let search = to.hash.split("?refer=")[1];
    next("/auth_login?refer=" + search);
  }
  let _access = new GuestAccess();
  if ((_a = to.meta) == null ? void 0 : _a.access) {
    _access = to.meta.access;
  }
  if ((_b = to.meta) == null ? void 0 : _b.title) {
    document.title = to.meta.title;
  }
  if ((_c = to.meta) == null ? void 0 : _c.options) {
    const _viewOptions = (_d = to.meta) == null ? void 0 : _d.options;
    const _options = yield _viewOptions.options(to, from, next);
    if (_options === false) {
      next("/404");
    }
  }
  _access.next(to, from, next);
}));
export default router;
